import { Variants } from '../types/variant';

export const medGCourtVariants = {
  // ALDO-2908. Key `med_g_court`, not `med-g-court`: the key is also a value of
  // the Prisma `QuestionnaireVariant` enum, which rejects hyphens. The KB lives
  // in its own directory (knowledgebase `src/med-g-court/`, speciality
  // `MED-G-COURT`) and shares nothing with `med-g`.
  med_g_court: {
    name: 'Médecine générale (version courte)',
    status: 'beta',
    availableInDemo: false,
    description:
      "Questionnaire court de médecine générale pour les soins non programmés (10 à 15 questions). Motif en texte libre et besoin d'arrêt de travail ; pour un nouveau patient : antécédents, traitements, allergies, grossesse, taille, poids et mode de vie ; pour un patient connu : ce qui a changé depuis la dernière consultation. Propose enfin d'aborder la prévention en consultation.",
    speciality: 'MED-G-COURT',
    patientOnboarding: 'MED_G',
    patientOffboarding: 'DEFAULT',
    emailTemplate: 'MED_G_DEFAULT',
    // Raw passthrough: the report repeats the patient's answers, one section
    // per theme, as agreed with the practice.
    reportTemplate: 'BASIC_SPECIALTY',
    initialQuestions: [],
    initialAssertions: [
      "[Message: #‹]-(06.a_lieu_emission)->[Lieu]-(01.DESCR)->[Salle d'Attente]-(PART_OF)->[Cabinet Médical: #c]",
      '[Médecin: #z‹]-(a_spécialité)->[Médecine Générale]',
    ],
    // Section order is the question order: each conditional block (pregnancy,
    // tobacco and alcohol, activity, profession) has its own section, so no
    // `(après)` in the KB points at a question that may not be asked.
    pages: {
      CONSULTATION: {
        title: 'Consultation',
        sections: ['CONTEXTE'],
      },
      COMPLAINTS: {
        title: 'Motif',
        sections: ['MOTIF'],
      },
      HISTORY: {
        title: 'Votre santé',
        sections: ['ATCD', 'GROSSESSE', 'MENSURATION', 'SUIVI'],
      },
      LIFESTYLE: {
        title: 'Mode de vie',
        sections: ['HABITUDES', 'ACTIVITE', 'PROFESSION'],
      },
      PREVENTION: {
        title: 'Prévention',
        sections: ['PREVENTION'],
      },
    },
    options: ['COMPACT'],
  },
} satisfies Variants;
